import PropTypes from 'prop-types';
import React from 'react';

import Heading from '@bibliocommons/heading';
import { PrimarySolidLink } from '@bibliocommons/base-links';

import { linksMappedProps } from 'app/shapes/browse/rows';

import './Links.scss';

export default function Links({ additionalAnalyticsPayload, links, trackClick, title }) {
  function renderLinks(link, index) {
    const itemPosition = index + 1; // 1-based count for analytics

    const { title: linkText, url: linkUrl } = link;

    return (
      <li className="link-content" key={linkUrl}>
        <PrimarySolidLink
          handleClick={() =>
            trackClick({ ...additionalAnalyticsPayload, itemPosition, linkText, linkUrl, uiContainerTitle: title })}
          href={linkUrl}
          dataKey="link-primary"
          className="link-primary"
          size="large"
        >
          {linkText}
        </PrimarySolidLink>
      </li>
    );
  }

  return (
    <div className="cp-browse-links">
      <Heading tagName="h2" size="moderate" variant>
        <span>{title}</span>
      </Heading>
      <ul className="links-row-contents">{links.map(renderLinks)}</ul>
    </div>
  );
}

Links.defaultProps = {
  additionalAnalyticsPayload: {}
};

Links.propTypes = {
  ...linksMappedProps,
  additionalAnalyticsPayload: PropTypes.object,
  trackClick: PropTypes.func.isRequired
};
